import styled from 'styled-components';

export const StyledNoThreadsContainer = styled.div`
    display: flex;
    min-height: 40rem;

    > * {
        margin: auto;
    }
`;
